import React from 'react'
import { useTheme } from '../Context/ThemeContext'

function Mail({ mail }) {

    const { theme, primaryColor, secondaryColor, colors, selectedColor } = useTheme();

    return (
        <div className={`after:block after:w-[2px] after:h-24 after:rounded-md after:mx-auto after:my-auto after:${colors[theme].colors[selectedColor].bgPrimary}`}>
            <a className={`${secondaryColor} hover:${primaryColor} mb-5 vertical-rl cursor-pointer text-lg transition ease-in duration-300 hover:-translate-y-2`} href={`mailto:${mail}`}>
                {mail}
            </a>
        </div>
    )
}

export default Mail